// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"693":"603f1dc8","694":"3d5821b8"}[chunkId] + ".chunk.css";
};